import types from './types'

export default {
  setAffectedApplicationData(context, affectedAppData) {
    context.commit(types.SET_AFFECTED_APP, affectedAppData)
  },
}
